export const RQ_KEY = {
  orderStatusServiceOrderStatusGetV1: (
    restaurantId: string,
    orderId: string,
  ) => [`/v1/instore_kiosk/oder_status/${restaurantId}/${orderId}`],
} as const;
